var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"mt-4",attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"align":"center"}},[_c('iframe',{attrs:{"height":"700","width":"1100","src":_vm.pdf}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }